import { StepsQuestionsView, TypeQuestionView } from '../models/client-questions';
import { Injectable } from '@angular/core';

@Injectable()
export class UsersService {

  public stepQuestion: StepsQuestionsView;
  public typeCustomQuestions: TypeQuestionView[];

  constructor() { }

  public initialize(stepsQuestionsView: StepsQuestionsView) {
    this.stepQuestion = stepsQuestionsView;
    this.typeCustomQuestions = stepsQuestionsView.questions;
  }
}
